// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homeContainer {
  display: flex;
  flex-direction: column;
}

.intro {
  padding: 40px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  margin: 20px auto;
}

.home-links {
  margin-left: 70px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 0px;
  margin-bottom: -8px;
  margin-top: 24px;
}

.intro-paragraph {
  width: 300px;
  text-align: right;
  animation: fadeIn linear 1.5s;
  font-size: 24px;
}

.home-link:hover {
  font-style: normal;
  margin-right: -16px;
}

.home-link {
  font-size: 88px;
  font-style: italic;
  margin-top: -90px;
  text-decoration: none;
  animation: homeLinkLoad 500ms ease-in;
}

.homeHr {
  border-top: 1px solid #000099;
}

@keyframes homeLinkLoad {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes skillsTitleLoad {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@media only screen and (max-width: 390px) {
  .intro {
    flex-direction: column;
    width: auto;
    padding: 20px;
    margin: 8 auto -32px;
    align-items: flex-start;
  }
  h1 {
    font-size: 56px;
  }
  .homeContainer {
    width: auto;
  }
  .home-links {
    margin-left: 0;
    margin-bottom: 0;
    margin-top: 0;
  }
  .home-link {
    margin-top: -32px;
  }
  .intro-paragraph {
    width: 100%;
    text-align: right;
    font-size: 16px;
  }
}

@media only screen and (min-width: 390px) and (max-width: 769px) {
  h1 {
    font-size: 104px;
  }
  .home-links {
    margin: 0;
  }
  .home-link {
    margin-top: -48px;
  }
  .intro {
    padding: 20px;
    flex-direction: column;
    width: auto;
    align-items: flex-end;
  }
  .intro-paragraph {
    font-size: 20px;
  }
}

@media only screen and (min-width: 770px) and (max-width: 1040px) {
  .intro {
    flex-direction: column;
    padding: 40px;
  }
  .home-link {
    font-size: 72px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".homeContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.intro {\n  padding: 40px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: center;\n  margin: 20px auto;\n}\n\n.home-links {\n  margin-left: 70px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  line-height: 0px;\n  margin-bottom: -8px;\n  margin-top: 24px;\n}\n\n.intro-paragraph {\n  width: 300px;\n  text-align: right;\n  animation: fadeIn linear 1.5s;\n  font-size: 24px;\n}\n\n.home-link:hover {\n  font-style: normal;\n  margin-right: -16px;\n}\n\n.home-link {\n  font-size: 88px;\n  font-style: italic;\n  margin-top: -90px;\n  text-decoration: none;\n  animation: homeLinkLoad 500ms ease-in;\n}\n\n.homeHr {\n  border-top: 1px solid #000099;\n}\n\n@keyframes homeLinkLoad {\n  0% {\n    transform: translateX(100%);\n  }\n\n  100% {\n    transform: translateX(0);\n  }\n}\n\n@keyframes skillsTitleLoad {\n  0% {\n    transform: translateX(-100%);\n  }\n\n  100% {\n    transform: translateX(0);\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@media only screen and (max-width: 390px) {\n  .intro {\n    flex-direction: column;\n    width: auto;\n    padding: 20px;\n    margin: 8 auto -32px;\n    align-items: flex-start;\n  }\n  h1 {\n    font-size: 56px;\n  }\n  .homeContainer {\n    width: auto;\n  }\n  .home-links {\n    margin-left: 0;\n    margin-bottom: 0;\n    margin-top: 0;\n  }\n  .home-link {\n    margin-top: -32px;\n  }\n  .intro-paragraph {\n    width: 100%;\n    text-align: right;\n    font-size: 16px;\n  }\n}\n\n@media only screen and (min-width: 390px) and (max-width: 769px) {\n  h1 {\n    font-size: 104px;\n  }\n  .home-links {\n    margin: 0;\n  }\n  .home-link {\n    margin-top: -48px;\n  }\n  .intro {\n    padding: 20px;\n    flex-direction: column;\n    width: auto;\n    align-items: flex-end;\n  }\n  .intro-paragraph {\n    font-size: 20px;\n  }\n}\n\n@media only screen and (min-width: 770px) and (max-width: 1040px) {\n  .intro {\n    flex-direction: column;\n    padding: 40px;\n  }\n  .home-link {\n    font-size: 72px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
